"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reaganCompatReporter = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var ReporterActionTypes = _interopRequireWildcard(require("./ReporterActionTypes"));

var _hubspot = _interopRequireDefault(require("hubspot"));

var _enviro = _interopRequireDefault(require("enviro"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _Raven = _interopRequireDefault(require("Raven"));

var _performance = _interopRequireDefault(require("../vendor/performance"));

var _performanceNow = _interopRequireDefault(require("../vendor/performanceNow"));

// TODO contentReady?
// TODO constants
// TODO make perform measures more accurate
// TODO state machine
var STATIC_DOMAIN_REGEX = /https:\/\/(static|local).hsappstatic.net\//; // If the duration of the request is <= 10ms mark the request as a cache hit.

var CACHE_DURATION_MS = 10;

var performanceMark = function performanceMark(name) {
  if (typeof _performance.default.mark === 'function') {
    _performance.default.mark(name);
  }
};

var performanceEntries = function performanceEntries() {
  if (typeof _performance.default.getEntries === 'function') {
    return _performance.default.getEntries();
  }

  return [];
}; // adapted from https://git.hubteam.com/HubSpot/Reagan/blob/41003ccc09f302efb6e6bd6f18064ca867200f84/static/js/reagan.js#L30


var sendAlert = function sendAlert(route, extra) {
  try {
    var exceptions = window.Q && typeof window.Q.getUnhandledReasons === 'function' ? window.Q.getUnhandledReasons().map(function (exception) {
      if (exception) {
        if (typeof exception === 'string') {
          return exception;
        } else {
          return exception.message || exception.responseText || exception.statusText;
        }
      }

      return undefined;
    }) : [];
    var marksArray = typeof _performance.default.getEntriesByType === 'function' ? _performance.default.getEntriesByType('mark') : [];
    var marks = marksArray.map(function (_ref) {
      var name = _ref.name,
          startTime = _ref.startTime;
      return {
        name: name,
        startTime: startTime
      };
    });

    _Raven.default.captureMessage("Reagan failure loading " + route, {
      logger: 'react-rhumb',
      tags: {
        deployed: _enviro.default.deployed('react-rhumb')
      },
      extra: (0, _extends2.default)({}, extra, {
        hash: window.location.hash,
        blockingModules: _hubspot.default.getBlockingModules(),
        erroredModules: _hubspot.default.getErroredModules(),
        exceptions: exceptions,
        marks: marks,
        time: Math.floor((0, _performanceNow.default)())
      })
    });
  } catch (e) {
    console.error(e);
  }
}; // mostly ported from reagan


var reaganCompatReporter = function reaganCompatReporter(newrelic) {
  if (!newrelic) {
    return function () {};
  }

  var lastAbandonedTimestamp = null;
  var abandonedTimes = [];

  var getHubHttpData = function getHubHttpData(finishedTimestamp) {
    if (typeof _hubspot.default.getAllHttpRequestStats === 'function' && typeof _performance.default.now === 'function') {
      var byStatus = function byStatus(status) {
        return function (_ref2) {
          var state = _ref2.state,
              started = _ref2.started,
              finished = _ref2.finished;
          return started < finishedTimestamp && (status === 'pending' ? state === 'pending' || finished > finishedTimestamp : state === status && finished <= finishedTimestamp);
        };
      };

      var MAX_URLS = 10;

      var toUrls = function toUrls(arr) {
        return arr.slice(0, MAX_URLS).map(function (r) {
          return r.url;
        }).join(',');
      };

      var requests = _hubspot.default.getAllHttpRequestStats();

      var succeededRequests = requests.filter(byStatus('succeeded'));
      var failedRequests = requests.filter(byStatus('failed'));
      var abortedRequests = requests.filter(byStatus('aborted'));
      var pendingRequests = requests.filter(byStatus('pending'));
      var timedOutRequests = requests.filter(byStatus('timedOut'));
      var failedRequestsMinus404AndRetries = failedRequests.filter(function (r) {
        return r.status !== 404 && !r.willBeRetried;
      });
      return {
        numSucceededRequests: succeededRequests.length,
        numAbortedRequests: abortedRequests.length,
        numPendingRequests: pendingRequests.length,
        numNotFound: failedRequests.filter(function (r) {
          return r.status === 404;
        }).length,
        numTimedoutRequests: timedOutRequests.length,
        numFailedRequestsMinus404AndRetries: failedRequestsMinus404AndRetries.length,
        numRetriedFailures: failedRequests.filter(function (r) {
          return !!r.willBeRetried;
        }).length,
        failedRequestUrls: toUrls(failedRequestsMinus404AndRetries),
        timedOutRequestUrls: toUrls(timedOutRequests),
        pendingRequestUrls: toUrls(pendingRequests)
      };
    }

    return null;
  };

  var getCacheStatusData = function getCacheStatusData() {
    var cacheStatusData = {};
    performanceEntries().forEach(function (timing) {
      if (timing.name.endsWith('.js')) {
        var fileName = timing.name.replace(STATIC_DOMAIN_REGEX, '');
        cacheStatusData[fileName] = {
          cached: timing.duration <= CACHE_DURATION_MS,
          duration: timing.duration
        };
      }
    });
    return cacheStatusData;
  };

  var finish = function finish(attrs) {
    var finishedTimestamp = attrs.finishedTimestamp;
    var hubHttpData = getHubHttpData(finishedTimestamp);
    var avgDurationBeforePreviousReaganAborts = abandonedTimes.reduce(function (acc, duration) {
      return acc + duration / abandonedTimes.length;
    }, 0);
    var cacheData = getCacheStatusData();
    newrelic.setCustomAttribute('numReaganChecksStarted', abandonedTimes.length + 1);
    newrelic.setCustomAttribute('numPreviousReaganChecksAborted', abandonedTimes.length);
    newrelic.setCustomAttribute('avgDurationBeforePreviousReaganAborts', avgDurationBeforePreviousReaganAborts);
    newrelic.setCustomAttribute('numPreviousReaganChecksFailed', 0);
    newrelic.setCustomAttribute('numPreviousReaganChecksSuccessful', 0);
    newrelic.setCustomAttribute('supportsUserTiming', typeof _performance.default.mark === 'function');
    newrelic.setCustomAttribute('supportsPerformanceTimeline', typeof _performance.default.getEntriesByType === 'function');
    newrelic.setCustomAttribute('supportsHighResolutionTime', typeof _performance.default.now === 'function');
    newrelic.addPageAction('reaganFinished', (0, _extends2.default)({}, attrs, hubHttpData, {
      cacheData: JSON.stringify(cacheData)
    }));
  };

  var finished = false;
  return function (action) {
    if (finished) {
      return;
    }

    var _action$payload = action.payload,
        _action$payload$entry = _action$payload.entry,
        timestamp = _action$payload$entry.timestamp,
        checks = _action$payload$entry.checks,
        pathname = _action$payload$entry.pathname,
        expiredTimestamp = _action$payload$entry.expiredTimestamp,
        routeSpec = _action$payload.routeSpec;

    switch (action.type) {
      case ReporterActionTypes.ROUTE_SUCCEEDED:
      case ReporterActionTypes.ROUTE_FAILED:
      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
      case ReporterActionTypes.ROUTE_UNEXPECTED:
        {
          finished = true;
          break;
        }

      default:
    }

    switch (action.type) {
      case ReporterActionTypes.ROUTE_STARTED:
        {
          if (lastAbandonedTimestamp) {
            abandonedTimes.push(timestamp - lastAbandonedTimestamp);
          }

          break;
        }

      case ReporterActionTypes.ROUTE_UNEXPECTED:
        {
          newrelic.addPageAction('react-rhumb-event', {
            eventName: 'UnexpectedRouteVisited',
            pathname: pathname
          });
          break;
        }

      case ReporterActionTypes.ROUTE_ABANDONED:
        {
          lastAbandonedTimestamp = timestamp;
          break;
        }

      case ReporterActionTypes.ROUTE_SUCCEEDED:
        {
          var success = routeSpec.success,
              route = routeSpec.route;
          var scenario = action.payload.extra.scenario;

          if (process.env.NODE_ENV !== 'production') {
            (0, _invariant.default)(success[scenario].length > 0, 'routeSpec for %s must have at least one `success` marker for %s', route, scenario);
          }

          var maxTimestamp = Math.max.apply(Math, (0, _toConsumableArray2.default)(success[scenario].map(function (m) {
            return checks[m].timestamp;
          })));
          var duration = Math.max(0, maxTimestamp - timestamp);
          finish({
            status: 'success',
            timeToAllSuccess: (timestamp + duration) / 1000,
            scenario: scenario,
            finishedTimestamp: maxTimestamp,
            route: route
          });
          performanceMark("mark_all_success");
          break;
        }

      case ReporterActionTypes.ROUTE_FAILED:
        {
          var _route = routeSpec.route,
              error = routeSpec.error;
          var markers = error.filter(function (marker) {
            return checks[marker] && checks[marker].mounted;
          });

          if (process.env.NODE_ENV !== 'production') {
            (0, _invariant.default)(markers.length > 0, 'routeSpec for %s must have at least one `failure` marker for', _route);
          } // TODO how to report multiple failed markers without separate page actions


          var _markers = (0, _slicedToArray2.default)(markers, 1),
              failedMarker = _markers[0];

          var finishedTimestamp = checks[failedMarker].timestamp;
          finish({
            status: 'failure',
            failureType: 'errorSelector',
            selector: failedMarker,
            finishedTimestamp: finishedTimestamp,
            route: _route
          });
          performanceMark("mark_all_failure");
          sendAlert(_route, {
            type: 'failure',
            markers: markers
          });
          break;
        }

      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
        {
          var _route2 = routeSpec.route,
              _success = routeSpec.success;

          var _markers2 = Object.keys(_success).reduce(function (acc, scenario) {
            _success[scenario].forEach(function (marker) {
              acc.add(marker);
            });

            return acc;
          }, new Set()); // eslint-disable-line no-restricted-globals


          finish({
            status: 'failure',
            failureType: 'watchdogExpired',
            finishedTimestamp: expiredTimestamp,
            route: _route2
          });
          performanceMark("mark_all_failure_watchdog_expired");
          sendAlert(_route2, {
            type: 'timeout',
            markers: _markers2
          });
          break;
        }

      default:
    }
  };
};

exports.reaganCompatReporter = reaganCompatReporter;